export default "__VITE_ASSET__Cle5hwZo__"